import React, { useState } from 'react'
import { Button, Card, Drawer, notification } from 'antd'
import { useDispatch } from 'react-redux'
import InputBox from '../../../components/_utils/InputBox'
import { editWithdrawalLimitFxn } from '../actions/user'

const EditLimitWithdrawalList = (props) => {
  let { visible, onClose, countryId, withdrawalLimitId, withdrawalLimit } = props
  const dispatch = useDispatch()
  const [newWithdrawalLimit, setNewWithdrawalLimit] = useState(withdrawalLimit)

  const handleSubmit = async () => {
    if (newWithdrawalLimit <= withdrawalLimit) {
      notification.warning({
        message: 'New withdrawal limit cannot be same or less than old withdrawal limit'
      })
      return
    }
    const resp = await dispatch(editWithdrawalLimitFxn({ withdrawalLimitId, newWithdrawalLimit, countryId }))
    if (resp.success) {
      onClose()
    }
  }

  return (
    <>
      <Drawer title={`Update Withdrawal Limit`} width={'25%'} onClose={onClose} visible={visible}>
        <Card>
          <InputBox title={'New Withdrawal Limit'}>
            <input
              type={'number'}
              value={newWithdrawalLimit}
              className={'form-control'}
              onChange={(e) => {
                setNewWithdrawalLimit(e.target.value)
              }}
            />
          </InputBox>
          <Button className={'btn btn-primary'} onClick={() => {
            handleSubmit()
          }}>Submit</Button>
          <Button className={'btn btn-default ml10'} onClick={onClose}>Cancel</Button>
        </Card>
      </Drawer>
    </>
  )
}
export default EditLimitWithdrawalList
